import { parsePhoneNumber } from "libphonenumber-js";

export const formatTelephone = (p: string) => parsePhoneNumber(p).formatInternational ();
export const formatAmount = (a : number, local: string = "de-CH") => new Intl.NumberFormat(local).format(a);